import { useDemoTimeAuth } from "root/client/src/hooks/useDemoTimeAuth";

export function useLogout() {
    const demotimeAuth = useDemoTimeAuth();
    return async () => {
      await demotimeAuth.logout();
    };
}
